import { HttpFetchProps } from './http-fetch-props';
import { HttpAdapter } from './http-adapter';

/** Adds a base URL to each request. */
export class BaseUrlHttpAdapter implements HttpAdapter {
  /** Base URL to add to each request. */
  private _baseUrl: string;

  constructor(baseUrl: string) {
    this._baseUrl = baseUrl;
  }

  /** @inheritdoc */
  adaptHttpRequest(request: HttpFetchProps): HttpFetchProps {
    return {
      ...request,
      url: `${this._baseUrl}/${request.url}`
    };
  }
}
